import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { compareDataByMeasureYearGradePeriod } from '../shared/filterUtils';
import {
    BURST_MEASURES,
    MEASURE,
    FR_EXPRESS_VIEW_MEASURES,
} from '../../constants/reading/MeasuresConstants';
import { D8_MEASURES } from '../../constants/shared/MeasuresConstants';
import { GRADE } from '../../constants/shared/GradesConstants';
import { LICENSE } from '../../constants/reading/CommonConstants';
import { NA, PERIOD } from '../../constants/shared/CommonConstants';
import { hasMeasureGradeNoExceptions } from '../shared/tableUtils';

const { BURST, D8, EXPRESS } = LICENSE;
const { OL, TRO, LEXILE } = MEASURE;
const { ALL_GRADES } = GRADE;

export const isBurstMeasure = measure => BURST_MEASURES.includes(measure);

/**
 * Filter out unlicensed measures
 */
export const getLicensedMeasures = (measures, licensingInfo) =>
    measures.filter(measure => {
        const measureKey = get(measure, 'key', measure);

        return (
            licensingInfo.includes(measureKey) ||
            (licensingInfo.includes(D8) && D8_MEASURES.includes(measureKey)) ||
            (licensingInfo.includes(BURST) && isBurstMeasure(measureKey)) ||
            (licensingInfo.includes(EXPRESS) && FR_EXPRESS_VIEW_MEASURES.includes(measureKey)) ||
            measureKey === LEXILE
        );
    });

export const getStudentStatusByYearGrade = (results, studentId, year, grade) =>
    results[studentId].statuses.find(
        status =>
            status.schoolYear === year && (grade === ALL_GRADES ? true : status.grade === grade),
    );

const isGoalNAForSummer = (grade, period, measure) =>
    period === PERIOD.SUMMER && grade !== GRADE.PREKINDERGARTEN && measure !== MEASURE.TRO;

export const getSpecificReadingGoal = (measure, grade, period) =>
    measure === OL || isGoalNAForSummer(grade, period, measure) ? NA : null;

export const getGoalByMeasureGradePeriod = (interps, measure, grade, period) => {
    if (measure === TRO) return '';
    if (!hasMeasureGradeNoExceptions(measure, grade, period)) return NA;
    const interpObject = interps.find(interp =>
        compareDataByMeasureYearGradePeriod(interp, measure, null, grade, period),
    );
    if (!isEmpty(interpObject)) {
        return interpObject.goal;
    }
    return getSpecificReadingGoal(measure);
};
